import httpClient from "./httpClient";

class TestimonialsApi {
    getTestimonials = async ({perPage = 15, page = 1}) => {
        const response = await httpClient.get('/cheap-study/v1/testimonials/', {
            params: {
                per_page: perPage,
                page
            }
        });
        return {
            data: response.data,
            pages: Number(response.headers.get('X-Total-Pages')),
            posts: Number(response.headers.get('X-Total-Posts')),
        };
    }
}

export const testimonialsApi = new TestimonialsApi();